export default __webpack_public_path__ + "static/media/our-partner-logo-6.9dffd200.svg";